import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface AccordionItem {
  title: string;
  content: string[];
}

interface AccordionProps {
  title: string;
  items: AccordionItem[];
}

const Accordion: React.FC<AccordionProps> = ({ title, items }) => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const toggleItem = (index: number) => {
    setOpenItems(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-xl font-bold text-[#1F2937]">{title}</h3>
      </div>
      
      <div className="divide-y divide-gray-200">
        {items.map((item, index) => (
          <div key={index}>
            <button
              onClick={() => toggleItem(index)}
              className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
              aria-expanded={openItems.includes(index)}
            >
              <span className="font-semibold text-[#1F2937]">{item.title}</span>
              <ChevronDown 
                className={`w-5 h-5 text-[#FF5A1F] transition-transform duration-200 ${
                  openItems.includes(index) ? 'rotate-180' : ''
                }`}
              />
            </button>
            
            {openItems.includes(index) && (
              <div className="px-6 pb-4">
                <ul className="space-y-2">
                  {item.content.map((contentItem, contentIndex) => (
                    <li key={contentIndex} className="text-[#334155] flex items-start space-x-2">
                      <span className="w-2 h-2 bg-[#FF5A1F] rounded-full mt-2 flex-shrink-0"></span>
                      <span>{contentItem}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Accordion;